<template>
  <div class="main">
    <div class="link-party-list">
      <h1 class="title">Link Party List</h1>

      <div v-if="isLoading">Loading Link Party list...</div>
      <div v-else-if="error">Error loading Link Party list: {{ error }}</div>

      <div v-else>
        <div class="controls">
          <div class="search-container">
            <input v-model="searchQuery" placeholder="Search..." />
            <i class="fas fa-search search-icon"></i>
          </div>
          <div class="actions">
            <button class="add-button" @click="openAddOverlay" title="Add New Link Party"
              :disabled="isEditing || showAddModal || isSubmitting">
              <i class="fas fa-plus"></i>
            </button>
            <div class="export-container">
              <button class="export-button" @click="toggleExportOptions" title="Export">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <ul v-if="showExportOptions" class="export-options">
                <li @click="exportToCSV">Export to CSV</li>
                <li @click="exportToPDF">Export to PDF</li>
              </ul>
            </div>
          </div>

        </div>

        <!-- Add Modal -->
        <div v-if="showAddModal" class="modal-overlay">
          <div class="modal-content small">
            <div class="modal-header">
              <h3 style="margin: 0;">Add Link Party</h3>
              <button class="close-btn" @click="cancelAdd">&times;</button>
            </div>
            <div class="modal-body">
              <div class="edit-grid">
                <div class="form-group full">
                  <label>Short Name</label>
                  <input v-model="newParty.short_name" />
                </div>

                <div class="form-group">
                  <label>Applicant</label>
                  <v-select :clearable="false" v-model="newParty.applicantId" :options="applicants"
                    label="applicantname" :reduce="applicant => applicant.applicantid" selectOnTab="True"
                    placeholder="Select Applicant *" append-to-body />
                </div>

                <div class="form-group">
                  <label>Account</label>
                  <v-select :clearable="false" v-model="newParty.accountId" :options="accounts" label="accountname"
                    :reduce="account => account.accountid" selectOnTab="True" placeholder="Select Account *"
                    append-to-body />
                </div>
                <div class="form-group">
                  <label>Reporting Applicant</label>
                  <v-select :clearable="false" v-model="newParty.report_app" :options="applicants" label="applicantname"
                    :reduce="applicant => applicant.applicantid" selectOnTab="True" placeholder="Select Applicant"
                    append-to-body />
                </div>

                <div class="form-group">
                  <label>Reporting Account</label>
                  <v-select :clearable="false" v-model="newParty.report_acc" :options="accounts" label="accountname"
                    :reduce="account => account.accountid" selectOnTab="True" placeholder="Select Account"
                    append-to-body />
                </div>
                <div class="form-group">
                  <label>Billing Applicant</label>
                  <v-select :clearable="false" v-model="newParty.bill_app" :options="applicants" label="applicantname"
                    :reduce="applicant => applicant.applicantid" selectOnTab="True" placeholder="Select Applicant"
                    append-to-body />
                </div>
                <div class="form-group">
                  <label>Billing Account</label>
                  <v-select :clearable="false" v-model="newParty.bill_acc" :options="accounts" label="accountname"
                    :reduce="account => account.accountid" selectOnTab="True" placeholder="Select Account"
                    append-to-body />
                </div>
                <div class="form-group">
                  <label>Sender ID</label>
                  <input v-model="newParty.senderid" placeholder="Sender ID" />
                </div>
                <div class="form-group">
                  <label>Auth Representative Code</label>
                  <input v-model="newParty.authreprsntvcd" placeholder="Auth Representative Code" />
                </div>
                <div class="form-group">
                  <label>Submitter Code</label>
                  <input v-model="newParty.sbmtrcd" placeholder="Submitter Code" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="cancel-button" @click="cancelAdd" :disabled="isSubmitting">Cancel</button>
              <button class="save-button" @click="saveParty" :disabled="isSubmitting">Save</button>
            </div>
          </div>
        </div>

        <!-- Edit Modal -->
        <div v-if="showEditModal" class="modal-overlay">
          <div class="modal-content small">
            <div class="modal-header">
              <h3 style="margin: 0;">Edit Link Party</h3>
              <button class="close-btn" @click="cancelEdit">&times;</button>
            </div>
            <div class="modal-body">
              <div class="edit-grid">
                <div class="form-group full">
                  <label>Short Name</label>
                  <input v-model="newParty.short_name" />
                </div>

                <div class="form-group">
                  <label>Applicant</label>
                  <v-select :clearable="false" v-model="newParty.applicantId" :options="applicants"
                    label="applicantname" :reduce="applicant => applicant.applicantid" selectOnTab="True"
                    placeholder="Select Applicant *" append-to-body />
                </div>

                <div class="form-group">
                  <label>Account</label>
                  <v-select :clearable="false" v-model="newParty.accountId" :options="accounts" label="accountname"
                    :reduce="account => account.accountid" selectOnTab="True" placeholder="Select Account *"
                    append-to-body />
                </div>

                <div class="form-group">
                  <label>Reporting Applicant</label>
                  <v-select :clearable="false" v-model="newParty.report_app" :options="applicants" label="applicantname"
                    :reduce="applicant => applicant.applicantid" selectOnTab="True" placeholder="Select Applicant *"
                    append-to-body />
                </div>

                <div class="form-group">
                  <label>Reporting Account</label>
                  <v-select :clearable="false" v-model="newParty.report_acc" :options="accounts" label="accountname"
                    :reduce="account => account.accountid" selectOnTab="True" placeholder="Select Account *"
                    append-to-body />
                </div>
                <div class="form-group">
                  <label>Billing Applicant</label>
                  <v-select :clearable="false" v-model="newParty.bill_app" :options="applicants" label="applicantname"
                    :reduce="applicant => applicant.applicantid" selectOnTab="True" placeholder="Select Applicant *"
                    append-to-body />
                </div>
                <div class="form-group">
                  <label>Billing Account</label>
                  <v-select :clearable="false" v-model="newParty.bill_acc" :options="accounts" label="accountname"
                    :reduce="account => account.accountid" selectOnTab="True" placeholder="Select Account *"
                    append-to-body />
                </div>
                <div class="form-group">
                  <label>Sender ID</label>
                  <input v-model="newParty.senderid" placeholder="Sender ID" />
                </div>

                <div class="form-group">
                  <label>Auth Representative Code</label>
                  <input v-model="newParty.authreprsntvcd" placeholder="Auth Representative Code" />
                </div>

                <div class="form-group">
                  <label>Submitter Code</label>
                  <input v-model="newParty.sbmtrcd" placeholder="Submitter Code" />
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <button class="cancel-button" @click="cancelEdit" :disabled="isSubmitting">Cancel</button>
              <button class="save-button" @click="updateParty" :disabled="isSubmitting">Save</button>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="link-party-table">
            <thead>
              <tr>
                <th>Short Name</th>
                <th>Applicant Name</th>
                <th>Account Name</th>
                <th>Report App</th>
                <th>Report Acc</th>
                <th>Bill App</th>
                <th>Bill Acc</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>


              <!-- Existing Rows -->
              <tr v-for="(party) in paginatedParties" :key="party.autoid"
                :class="{ 'editing': party === selectedParty }">
                <td>{{ party.short_name }}</td>
                <td>{{ party.applicantname }}</td>
                <td>{{ party.accountname }}</td>
                <td>{{ party.rep_appname }}</td>
                <td>{{ party.rep_accname }}</td>
                <td>{{ party.bill_appname }}</td>
                <td>{{ party.bill_accname }}</td>

                <td>
                  <button @click="editParty(party)" class="edit-button" :disabled="showAddModal || isSubmitting"><i
                      class="fas fa-edit"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bottom-controls">
          <div class="rows-per-page">
            <button @click="setRowsPerPage(10)">10</button>
            <button @click="setRowsPerPage(20)">20</button>
            <button @click="setRowsPerPage(30)">30</button>
          </div>
          <div class="pagination">
            <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">&lt;</button>
            <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
              :class="{ active: page === currentPage }">
              {{ page }}
            </button>
            <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">&gt;</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      parties: [],
      showExportOptions: false,
      showEditModal: false,
      showAddModal: false,
      isLoading: false,
      error: null,
      searchQuery: '',
      rowsPerPage: 10,
      currentPage: 1,
      selectedParty: null,
      isSubmitting: false,
      nameCheckTimeout: null,
      newParty: {
        short_name: '',
        applicantId: 0,
        accountId: 0,
        report_app: 0,
        report_acc: 0,
        bill_app: 0,
        bill_acc: 0,
        senderid: '',
        authreprsntvcd: '',
        sbmtrcd: ''
      },
      shortNameError: '',
      applicants: JSON.parse(localStorage.getItem('applicants')) || [],
      accounts: JSON.parse(localStorage.getItem('accounts')) || [],
    };
  },
  created() {
    this.fetchLinkParties();
  },
  computed: {
    filteredParties() {
      return this.parties.filter(party => party.short_name.toLowerCase().includes(this.searchQuery.toLowerCase()));
    },
    paginatedParties() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      return this.filteredParties.slice(start, start + this.rowsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredParties.length / this.rowsPerPage);
    },
    isEditing() {
      return this.selectedParty !== null;
    },
  },
  watch: {
    'newParty.short_name': function (newShortName) {
      this.shortNameError = '';
      // Only check for duplicates when user stops typing, not on every keystroke
      clearTimeout(this.nameCheckTimeout);
      this.nameCheckTimeout = setTimeout(() => {
        if (newShortName && newShortName.trim() !== '') {
          this.checkShortNameUniqueness(newShortName, this.selectedParty?.autoid);
        }
      }, 500);
    },
  },
  methods: {
    async fetchLinkParties() {
      if (this.isSubmitting) return;

      this.isLoading = true;
      this.isSubmitting = true;
      this.error = null;

      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          this.error = 'No token found in localStorage';
          useToast().error('Authentication token not found.');
          return;
        }

        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/linkParties', config);
        this.parties = response.data[2];
      } catch (error) {
        console.error('Error fetching link parties:', error);
        this.error = 'Error fetching link parties. Check console for details.';
        useToast().error(error.response?.data?.message || 'Error fetching link parties.');
      } finally {
        this.isLoading = false;
        this.isSubmitting = false;
      }
    },
    openAddOverlay() {
      if (this.isEditing) {
        this.cancelEdit();
      }
      this.showAddModal = true;
      this.resetNewParty();
    },
    resetNewParty() {
      this.newParty = {
        short_name: '',
        applicantId: 0,
        accountId: 0,
        report_app: 0,
        report_acc: 0,
        bill_app: 0,
        bill_acc: 0,
        senderid: '',
        authreprsntvcd: '',
        sbmtrcd: ''
      };
      this.shortNameError = '';
    },
    toggleExportOptions() {
      this.showExportOptions = !this.showExportOptions;
      //console.log(this.showExportOptions);
      document.addEventListener('click', this.handleOutsideClick);
    },
    handleOutsideClick(event) {
      if (!event.target.closest('.export-container')) {
        this.showExportOptions = false;
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    async checkShortNameUniqueness(shortName, autoid = 0) {
      const toast = useToast();

      if (!shortName || shortName.trim() === '') {
        return false;
      }

      const exists = this.parties.some(party => party.short_name.toLowerCase() === shortName.toLowerCase() && party.autoid !== autoid);

      if (exists) {
        toast.error('Short name already exists. Please enter a unique short name.');
        return false;
      }

      return true;
    },
    async saveParty() {
      if (this.isSubmitting) return;

      const toast = useToast();
      this.shortNameError = '';

      // Mandatory field validation
      if (!this.newParty.short_name || this.newParty.short_name.trim() === '') {
        toast.error('Short Name is required.');
        return;
      }

      if (!this.newParty.applicantId || this.newParty.applicantId === 0) {
        toast.error('Applicant selection is required.');
        return;
      }

      if (!this.newParty.accountId || this.newParty.accountId === 0) {
        toast.error('Account selection is required.');
        return;
      }

      // Check for duplicate short names
      const nameValidation = await this.checkShortNameUniqueness(this.newParty.short_name);
      if (!nameValidation) {
        return;
      }

  this.isSubmitting = true;
  let shouldRefresh = false;
  try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }

        const config = {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        };
        const qrydata = {
          qry: this.newParty
        }
        const data = new FormData();
        const transdt = JSON.stringify(qrydata)
        data.append('transaction', transdt)

        await axios.post('/createpartylink', data, config);
        toast.success('Link Party Created Successfully!');
        // mark that we should refresh after submission completes
        shouldRefresh = true;
        this.showAddModal = false;
        this.selectedParty = null;
      } catch (error) {
        console.error('Error saving link party:', error);
        toast.error(error.response?.data?.message || 'Error saving link party.');
      } finally {
        this.isSubmitting = false;
      }
      // refresh the table after submission finished
      if (shouldRefresh) {
        await this.fetchLinkParties();
      }
    },
    async editParty(party) {
      this.newParty = { ...party };
      this.selectedParty = party;
      this.showEditModal = true;
    },
    async updateParty() {
      if (this.isSubmitting) return;

      const toast = useToast();
      this.shortNameError = '';

      // Mandatory field validation
      if (!this.newParty.short_name || this.newParty.short_name.trim() === '') {
        toast.error('Short Name is required.');
        return;
      }

      if (!this.newParty.applicantId || this.newParty.applicantId === 0) {
        toast.error('Applicant selection is required.');
        return;
      }

      if (!this.newParty.accountId || this.newParty.accountId === 0) {
        toast.error('Account selection is required.');
        return;
      }

      // Check for duplicate short names (exclude current party)
      const nameValidation = await this.checkShortNameUniqueness(this.newParty.short_name, this.selectedParty.autoid);
      if (!nameValidation) {
        return;
      }

  this.isSubmitting = true;
  let shouldRefresh = false;
  try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }

        const config = {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        };
        const qrydata = {
          qry: this.newParty
        }
        const data = new FormData();
        const transdt = JSON.stringify(qrydata)
        data.append('transaction', transdt)
        await axios.put(`/updatepartylink/${this.selectedParty.autoid}`, data, config);
        toast.success('Link Party Updated Successfully!');
        // mark that we should refresh after submission completes
        shouldRefresh = true;
        this.selectedParty = null;
        this.showEditModal = false;
        this.resetNewParty();
      } catch (error) {
        console.error('Error updating link party:', error);
        toast.error(error.response?.data?.message || 'Error updating link party.');
      } finally {
        this.isSubmitting = false;
      }
      // refresh the table after submission finished
      if (shouldRefresh) {
        await this.fetchLinkParties();
      }
    },
    cancelAdd() {
      this.showAddModal = false;
      this.resetNewParty();
    },
    cancelEdit() {
      this.selectedParty = null;
      this.resetNewParty();
      this.showEditModal = false;
    },
    setRowsPerPage(number) {
      this.rowsPerPage = number;
    },
    goToPage(page) {
      this.currentPage = page;
    },
  },
};
</script>




<style scoped>
.main {
  background-color: #f0f2f5;
  font-family: 'Roboto', sans-serif;
}

.link-party-list {
  padding: 20px;
}

.title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-container {
  position: relative;
}

.search-container input {
  padding: 8px 30px 8px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #666;
  cursor: pointer;
}

.actions {
  display: flex;
  align-items: center;
}

.table-container {
  max-height: 500px;
  overflow: auto;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.link-party-table {
  width: 100%;
  border-collapse: collapse;
}

.link-party-table th,
.link-party-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.link-party-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.edit-button,
.save-button,
.cancel-button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 18px;
}

.edit-button:disabled,
.save-button:disabled,
.cancel-button:disabled {
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.save-button {
  color: green;
}

.cancel-button {
  color: red;
}

.add-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.new-row input,
.new-row .v-select {
  width: 100%;
  padding: 5px;
  margin: 5px 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
}

.bottom-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.rows-per-page {
  display: flex;
  align-items: center;
}

.rows-per-page button {
  margin-left: 10px;
  padding: 5px 10px;
  border: none;
  background-color: #f2f2f2;
  color: #333;
  font-size: 14px;
  border-radius: 30px;
  cursor: pointer;
}

.rows-per-page button:hover {
  background-color: rgb(50, 89, 187);
  color: white;
}

.pagination {
  display: flex;
  align-items: center;

}

.pagination button {
  margin-left: 5px;
  padding: 5px 10px;
  border: none;
  background-color: #f2f2f2;
  color: #333;
  font-size: 14px;
  border-radius: 20px;
  cursor: pointer;
}

.pagination button:hover {
  background-color: rgb(50, 89, 187);
  color: white;
}

.error-message {
  color: #d9534f;
  font-size: 12px;
  margin-bottom: 4px;
  padding: 4px;
  border: 1px solid #d9534f;
  border-radius: 4px;
  background-color: #f9d6d5;
  display: inline-block;
}

.editing {
  background-color: #e0f7fa;
  /* Light blue background for editing row */
}

.export-container {
  position: relative;
  /* Add this */
}

.export-button {
  background-color: rgb(50, 89, 187);
  color: white;
  border: none;
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  position: relative;
  height: 32px;
  margin-left: 10px;
  /* Space between buttons */
}

.export-options {
  display: block;
  top: 100%;
  /* Update this to be relative to the .export-container */
  right: 0;
  /* Update this to be relative to the .export-container */
  /* ... existing styles ... */
}

.export-button:hover {
  background-color: rgb(61, 146, 231);
}

.add-button {
  background-color: rgb(50, 89, 187);
  color: white;
  border: none;
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  position: relative;
}

.add-button:hover {
  background-color: rgb(61, 146, 231);
}

/* Modal styles for edit dialog */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.modal-content.small {
  /* increased width for more comfortable editing space */
  width: 760px;
  max-width: 96%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  /* make modal a column flex container so header/footer remain fixed
     and the body scrolls when content grows. Limit height to viewport. */
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 5px;
  border-bottom: 1px solid #eee;
}

.modal-body {
  padding: 12px 16px;
  /* allow the modal body to scroll when content exceeds available space */
  overflow-y: auto;
  flex: 1 1 auto;
}

.modal-footer {
  padding: 12px 16px;
  border-top: 1px solid #eee;
  text-align: right;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.edit-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px 16px;
  align-items: start;
}

.edit-grid .form-group {
  display: flex;
  flex-direction: column;
}

.edit-grid .form-group.full {
  grid-column: 1 / -1;
}

.edit-grid label {
  font-weight: 600;
}

.edit-grid input {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
</style>
<!-- Global styles to ensure dropdown from vue-select (appended to body) sits above modals -->
<style>
/* Vue Select dropdown (appended to body) sometimes appears under fixed modals; raise its z-index */
.vs__dropdown-menu {
  z-index: 12000 !important;
}

/* If vue-select uses a different wrapper class when appended, cover common variants */
.v-select .vs__dropdown-menu {
  z-index: 12000 !important;
}
</style>
